import styled from "styled-components";
import { Flex } from "../Box";

const StyledBottomNav = styled(Flex)`
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 5px 8px;
  background: ${({ theme }) => theme.colors.backgroundAlt};
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  padding-bottom: env(safe-area-inset-bottom);
  html[data-useragent*="TokenPocket_iOS"] & {
    padding-bottom: 45px;
  }
  z-index: 20;
  /* five equal columns: the raised centre button stays centred and the spacing stays symmetric at 360 */
  & > * {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    justify-content: center;
  }
`;

export default StyledBottomNav;
